import { useQuery } from "@apollo/client";
import { useAuth0 } from '@auth0/auth0-react';
import _ from 'lodash';
import { useEffect } from 'react';
import { Location, useLocation, useNavigate } from "react-router-dom";

import { Alert, Box, Typography } from '@mui/material';
import { CircularProgressBackdrop } from './common';
import ReactGA from 'react-ga4';

import { OptionTemplate } from '../interfaces';
import { isExistingCommitteeLocation } from '../interfaces/locations';
import { getAccount, getAllActiveTemplates } from '../queries';
import { useGlobalStore } from "../store";
import Welcome from './newCampaign/Welcome';
import SellerInfoCard from './seller/SellerInfoCard';

import { useTheme } from '@mui/material/styles';


function Landing() {
  const theme = useTheme();
  const navigate = useNavigate();
  const location: Location = useLocation();
  const buyer = useGlobalStore((state) => state.buyer);
  const { user, isLoading: isAuthLoading } = useAuth0();

  // if a user is still logged in let's redirect them to tools page
  const isCreatingAnotherCommittee = isExistingCommitteeLocation(location.state);
  const hasSelectedCommittee = !_.isEmpty(buyer);

  const email = user?.email || '';
  const { loading: isAccountLoading } = useQuery(
    getAccount,
    {
      variables: { email },
      skip: email === ''
    }
  );

  useEffect(() => {
    if (hasSelectedCommittee && !isCreatingAnotherCommittee) {
      navigate('/', { replace: true });
    }
  }, [hasSelectedCommittee, isCreatingAnotherCommittee, navigate]);

  const { loading, error, data: templatesWithStates } = useQuery(getAllActiveTemplates);

  const isRedirectPending = !isCreatingAnotherCommittee &&
    (isAuthLoading || isAccountLoading || hasSelectedCommittee);

  ReactGA.event({
    category: "landing page",
    action: "viewLandingPage",
    label: "view landing page listing sellers"
  });

  if (error) {
    console.error(error);
    
    return(
      <Alert severity="error">
        There was an error loading the page.
        Please refresh your page and try again, or contact the seller.
      </Alert>
    )
  }
  let optionTemplates: OptionTemplate[] = []
  if (templatesWithStates) {
    optionTemplates = [...templatesWithStates.optionTemplates]
    optionTemplates.sort((a, b) => {
      if (a.seller.name.toUpperCase() > b.seller.name.toUpperCase()) {
        return 1
      }
      if (a.seller.name.toUpperCase() < b.seller.name.toUpperCase()) {
        return -1
      }
      return 0
    })
  }

  return (
    <Box sx={{ pt: 4 }}>
      <CircularProgressBackdrop open={loading || isRedirectPending} />
      <Welcome /> 
      <Box sx={{ backgroundColor: theme.palette.common.yellowBackground, pb: 2, pt:2, pr: 6, pl: 6}}>
        <Typography variant={'h5'} sx={{ paddingBottom: 2 }}>
          Available Sellers
        </Typography>
        { optionTemplates.map((template: OptionTemplate) => (
          <SellerInfoCard key={template.id} template={template}/>
        ))}
      </Box>
    </Box>
  );
}

export default Landing;
